import clsx from 'clsx';
import React from 'react';

import giftIcon from 'images/referral/giftbox_icon.svg';

import LinkCopy from '@components/LinkCopy';

import styles from './HeaderStyles.module.scss';

const HeaderSection = ({ referralUrl }: { referralUrl: string }) => {
  return (
    <div className={styles.referralHeaderContainer}>
      <div className={clsx(styles.actionContainer)}>
        <div className={clsx(styles.sectionContainer, 'container')}>
          <div className={clsx(styles.sectionWrapper, 'row')}>
            <div className={clsx(styles.sectionHeader, 'col-sm-12')}>
              The Information is better when friends & colleagues <strong>read together</strong>
            </div>
            <div className={clsx(styles.inviteLinkContainer, 'col-sm-12')}>
              <div className={styles.redBanner}></div>
              <div className={styles.inviteLinkWrapper}>
                <div className={clsx(styles.inviteLinkContent, 'container')}>
                  <img src={giftIcon} width={25} height={25} />
                  <div className={styles.inviteLinkHeader}>
                    As a benefit of your subscription, you can give 25% off access to The
                    Information.
                  </div>
                  <div className={styles.inviteLinkSubHeader}>
                    Share this custom offer link with friends and colleagues.
                  </div>
                  <div className={styles.referralLinkHeader}>Your custom invite link</div>
                  <div className={styles.linkWrapper}>
                    <LinkCopy
                      clipboardLink={referralUrl}
                      customClass={styles.linkContainerOverride}
                      trackingProps={{
                        'data-ahoy-name': 'Referral Landing Page - Click On Copy Referral Link',
                        'data-location': 'referral_landing_page',
                        'data-name': 'copy_referral_link',
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
